// import { conformsTo } from "lodash";
/**
 * 获取浪客jsonp接口参数
 */

import cookie from "../cookie";
let config = require("../../../config/web");
let hex_md5 = require('../md5');


let accountInfo: {
  lkCToken: string,
  lkUToken: string,
}

// //获取浪客通行证相关信息 /api/getlkinfos
// async function getlkinfos() {
//     let infos = await $.ajax({
//         url: '/api/getlkinfos',
//         type: 'GET',
//         dataType: 'json'
//     });

//     accountInfo = infos.result;

//     return accountInfo;
// };

/**
 * 生成随机字符串
*/
function mathrandomstr(num: number) {
  let data = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
  let result = "";
  for (let i = 0; i < num; i++) {
    let r = Math.floor(Math.random() * 16);
    result += data[r];
  }

  return result;
}
async function getLkJsonParam() {
  let lkCToken = cookie.get('lkCToken');
  let lkUToken = cookie.get('lkUToken');
  let params: any = {
    'device_id': "35dkmnjhbgtyhjko",
    'version': '1.0.0',
    'plat': 'Web',
    'product': 'EastMoney',
    'network': 'Wifi',
    'ctoken': lkCToken || '',
    'utoken': lkUToken || '',
    'model': 'pc',
    'osversion': '1.0'
  };

  // 用户登陆情况下
  let uid: string | null = cookie.get('uidal');
  if (uid) {
    uid = uid.substring(0, 16);
    params.device_id = hex_md5(uid)
  }
  else {
    if (cookie.get('langke_did')) {
      params.device_id = hex_md5(cookie.get('langke_did'))
    }
    else {
      // let did = mathrandomstr(20);
      let did = String((Math.random() + 1) * Math.pow(10, 20 - 1))
      cookie.set('langke_did', did, 10000)
      params.device_id = hex_md5(did)
    }
  }

  let res: string[] = [];
  for (let key in params) {
    res.push(`${key}=${params[key]}`)
  }
  return res.join('&')
}

async function getLkJsonParam2() {
  let lkCToken = "";
  let lkUToken = "";
  let params: any = {
    'device_id': "35dkmnjhbgtyhjko",
    'version': '1.0.0',
    'plat': 'Web',
    'product': 'EastMoney',
    'network': 'Wifi',
    'ctoken': lkCToken || '',
    'utoken': lkUToken || '',
    'model': 'pc',
    'osversion': '1.0'
  };

  // 用户登陆情况下
  let uid: string | null = cookie.get('uidal');
  if (uid) {
    uid = uid.substring(0, 16);
    params.device_id = hex_md5(uid)
  }
  else {
    if (cookie.get('langke_did')) {
      params.device_id = hex_md5(cookie.get('langke_did'))
    }
    else {
      // let did = mathrandomstr(20);
      let did = String((Math.random() + 1) * Math.pow(10, 20 - 1))
      cookie.set('langke_did', did, 10000)
      params.device_id = hex_md5(did)
    }
  }

  let res: string[] = [];
  for (let key in params) {
    res.push(`${key}=${params[key]}`)
  }
  return res.join('&')
}


/**
 * 获取浪客接口数据
 * @param url caifuhaoapi接口
 * @param option 参数
 */
async function getlkDate(url: string, option?: object): Promise<any> {
  let rnd = 'data' + Math.floor(Math.random() * 10000000 + 1)
  return await $.ajax({
    url: url,
    method: "GET",
    data: option || {},
    dataType: "jsonp",
    jsonpCallback: rnd
  })
}

/**
 * 浪客接口通用
 * @param urlPath 
 * @param option 
 */
export async function getLkApi(urlPath: string, option: any = {}) {
  let lkparams = await getLkJsonParam();
  let _url: string = `${config.getWebPath('lk')}${urlPath}?${lkparams}`;
  try {
    let json: any = await getlkDate(_url, option);
    if (json) { return json };
  } catch (error) {
    console && console.log(error);
    return false
  }
  return false;
};

/**
 * 不传ct ut
 * @param urlPath 
 * @param option 
 * @returns 
 */
export async function getLkApi2(urlPath: string, option: any = {}) {
  let lkparams = await getLkJsonParam2();
  let _url: string = `${config.getWebPath('lk')}${urlPath}?${lkparams}`;
  try {
    let json: any = await getlkDate(_url, option);
    if (json) { return json };
  } catch (error) {
    console && console.log(error);
    return false
  }
  return false;
};

export async function getLkBanner(urlPath: string, option: any = {}) {
  let lkparams = await getLkJsonParam();
  let _url: string = `${config.getWebPath('lkbanner')}${urlPath}?${lkparams}`;
  try {
    let json: any = await getlkDate(_url, option);
    // json = eval('('+json+')')
    if (json) { return json };
  } catch (error) {
    console && console.log(error);
  }
  return false;
};

/**
 * 不传ct ut
 * @param urlPath 
 * @param option 
 * @returns 
 */
export async function getLkBanner2(urlPath: string, option: any = {}) {
  let lkparams = await getLkJsonParam2();
  let _url: string = `${config.getWebPath('lkbanner')}${urlPath}?${lkparams}`;
  try {
    let json: any = await getlkDate(_url, option);
    // json = eval('('+json+')')
    if (json) { return json };
  } catch (error) {
    console && console.log(error);
  }
  return false;
};

/**
 * 获取行情push2接口数据
 * @param url push2接口
 * @param option 参数
 */
export async function getHqDate(url: string, option?: object): Promise<any> {
  return await $.ajax({
    url: url,
    method: "GET",
    data: option || {},
    dataType: "jsonp",
    jsonp: "cb"
  })
}

/**
 * 获取股吧jsonp接口参数
 */
function getGubaJsonParam() {
  let token: string = "ctoken=" + cookie.get('ct') + "utoken=" + cookie.get('ut') + "_519d77b29be442f8";
  let h: string = hex_md5(token);
  let result: string = `version=100&product=langke&plat=Web&h=${h}&deviceid=35dkmnjhbgtyhjko`;
  return result;
}

async function getGubaDate(url: string, option?: object): Promise<any> {
  return await $.ajax({
    url: url,
    method: "GET",
    data: option || {},
    dataType: "jsonp",
    jsonpCallback: "cb" + parseInt(Math.random() * 10000 + "")
  })
}

/**
 * 股吧接口通用
 * @param urlPath 
 * @param option 
 */
export async function getGubaApi(urlPath: string, option: any = {}) {
  let _url: string = `${config.getWebPath('guba')}${urlPath}?${getGubaJsonParam()}`;
  try {
    let json: any = await getGubaDate(_url, option);
    if (json) {
      return json;
    }
  } catch (error) {
    console && console.log(error);
  }
  return false;
}

/**
 * 获取公司简介
 */
export async function getCampanyInfo(code: string, mkt: string) {
  let _url = `//datacenter.eastmoney.com/api/data/get?type=RPT_ROADSHOW_ORGPROFILE&sty=SECUCODE,SECURITY_CODE,SECURITY_NAME_ABBR,TRADE_MARKET,ORG_PROFILE&extraCols=&filter=(SECURITY_CODE=%22${code}%22)(TRADE_MARKET=%22${mkt}%22)&p=1&ps=1&sr=&st=&token=&var=&source=Info&client=GB`;
  try {
    let json = await $.ajax({
      url: _url,
      method: "GET",
      dataType: "jsonp",
      jsonpCallback: "callback"
    })

    return json;
  } catch (error) {
    console && console.log(error);
  }
  return false;
}



/**
* 获取财富号接口数据
* @param url caifuhaoapi接口
* @param option 参数
*/
export async function getCfhDate(url: string, option?: object): Promise<any> {
  // 增加随机参数
  if (url.indexOf("caifuhaoapi") != -1) {
    option = $.extend(true, option, { businessid: Math.random() })
  }
  return await $.ajax({
    url: url,
    method: "GET",
    data: option,
    dataType: "jsonp"
  })
}
/**
 * 财富号接口通用
 * @param urlPath
 * @param option
 */

export async function getCfhApi(urlPath: string, option: any = {}) {
  let _url: string = `${config.getWebPath('cfh')}${urlPath}`;
  try {
    let json: any = await getCfhDate(_url, option);
    if (json) { return json };
  } catch (error) {
    console && console.log(error);
  }
  return false;
}


/**
 * 判断是否是数组
 * @param arg 
 */
function isArray(arg: any): boolean {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

/**
 * 查询用户是否订阅某一财富号作者
 * 
 * @param ids 订阅类型 1：财富号作者 2：财富号话题
 * @param type id列表 type=1:传财富号作者id， type=2：传话题id 多个按逗号分隔
 */
export async function isSubscribe(ids: string | string[], type: number): Promise<any> {
  if (!ids || type === undefined || type === null) {
    return false;
  }

  if (isArray(ids)) {
    ids = (ids as string[]).join(',')
  }

  try {
    let _url: string = `${config.getWebPath("cfh")}subscribe/IsSubscribe`;
    let json: any = await getCfhDate(_url, {
      type,
      ids
    })

    if (json && json.Result) {
      return json.Result;
    }
    return false;
  } catch (error) {
    console && console.log(error)
    return false;
  }
}


/**
 * 订阅/取消订阅  个人
 * @param hasFollow 是否已订阅
 * @param id 个人uid
 */
export async function FollowUser(hasFollow: boolean, id: string): Promise<boolean> {
  try {
    let _url: string = `${config.getWebPath("guba")}followopt/api/Follow/${hasFollow ? "CancelFollowUser4Jsonp" : "FollowUser4Jsonp"}`;
    let token: string = "ctoken=" + cookie.get('ct') + "utoken=" + cookie.get('ut') + "_519d77b29be442f8";
    let json: any = await getGubaDate(_url, {
      followuid: id,
      h: hex_md5(token),
      deviceid: hex_md5(id),
      version: "100",
      product: "CFH",
      plat: "Web",
      location: `WEB|video|videolist|TRUE|""`
    });
    if (json && json.rc === 1) {
      return true;
    }
    return false;
    // return json
  } catch (error) {
    console && console.log(error)
    return false;
  }

}


/**
 * 订阅/取消订阅  h话题
 * @param hasFollow 是否已订阅
 * @param followuid 个人uid
 */
export async function FollowTopic(hasFollow: boolean, id: string): Promise<boolean> {
  try {
    let _url: string = `${config.getWebPath('cfh')}subscribe/${hasFollow ? 'UnSubscribe' : 'Subscribe'}`;
    let json: any = await getCfhDate(_url, {
      id,
      type: 2
    })
    if (json && json.Status === 0) {
      return true;
    }
    return false;
    // return json
  } catch (error) {
    console && console.log(error)
    return false;
  }

}


/**
 * 正文点赞
 * @param isCancel 是否是取消点赞
 * @param type 类别
 * @param id 正文id
 */
export async function ZanArticle(isCancel: boolean, type: string, id: string) {
  let _url: string = `${config.getWebPath('guba')}/likeopt/JSONP/${isCancel ? "CancelLikeArticle" : "LikeArticle"}?${getGubaJsonParam()}`;
  try {
    let json: any = await getGubaDate(_url, {
      type,
      id
    });
    console.log(json)
    if (json && json.rc === 1) {
      return true;
    }
    return false;
  } catch (error) {
    console && console.log(error);
    return false;
  }
}

/**
 * 正文收藏
 * @param isCancel 是否是取消点赞
 * @param type 类别
 * @param id 正文id
 */
export async function CollectArticle(isCancel: boolean, id: string) {
  let _url: string = `${config.getWebPath('cfh')}/Article/${isCancel ? "DeleteAuthorfavoriteArticle" : "AddAuthorfavoriteArticle"}?artcode=${id}`;
  try {
    let json: any = await getCfhDate(_url);
    console.log(json)
    if (json.success == 0) {
      return true;
    }
    return false;
  } catch (error) {
    console && console.log(error);
    return false;
  }
}


interface subOption {
  pagesize: number;
  pageindex: number;
}

interface hotArticle extends subOption {
  timespan: string;
  columnid: string | number; // 栏目id 默认0: 不查栏目 >0:查询某个栏目下的热门文章
  withtopic: number;// 是否查询带话题的热门文章 默认0：不查询 1：查询带财富号话题的热门文章
}
/**
 * 获取热门文章列表
 * @param option 
 */
export async function GetHotArticleList(option: hotArticle): Promise<any> {
  try {
    let _url: string = `${config.getWebPath("cfh")}Article/GetHotArticleList`;
    let json: any = await getCfhDate(_url, option);
    if (json && json.Result && json.Result.length) {
      return json;
    }
    return false;
  } catch (error) {
    console && console.log(error)
    return false;
  }
}

/**
 * 财富号接口通用
 * @param urlPath 
 * @param option 
 */
export async function getVApi(urlPath: string, option: any = {}) {
  let _url: string = urlPath;
  try {
    let json: any = await getVData(_url, option);
    if (json) { return json };
  } catch (error) {
    console && console.log(error);
  }
  return false;
}


export async function getVData(url: string, option?: object): Promise<any> {
  return await $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',
    data: option || {}
  })
}


